import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

const Submit = ({
  title,
  disabled,
  loading,
  size,
  className,
  variant,
  onClick
}) => (
  <Button
    type="submit"
    variant={variant || "primary"}
    size={size || "sm"}
    className={className || null}
    disabled={disabled || loading}
    onClick={onClick}
  >
    <div className="d-flex justify-content-center align-items-center">
      {loading && (
        <Spinner
          as="span"
          animation="border"
          size={size || "sm"}
          role="status"
          aria-hidden="true"
          className="me-1"
        />
      )}
      <span>{title}</span>
    </div>
  </Button>
);

export default Submit;
